<ul
  [formGroup]="service.formGroup"
  class="{{ class }} {{
    !isHorizontal && question.questionEnum.enumValues.length >= 6
      ? 'column-count-' + roundUp(question.questionEnum.enumValues.length / 3)
      : ''
  }}"
  [class.list-options--horizontal]="isHorizontal"
>
  <li *ngFor="let enumValue of question.questionEnum.enumValues" class="enum-option">
    <div (click)="selectOption(enumValue)" class="enum-option-selectable">
      <input
        #input
        type="radio"
        [checked]="currentValue.includes(enumValue.value)"
        [value]="enumValue.value"
        [ngStyle]="{
          'accent-color': service.themeService.getThemeColor(
            service.themeService.ThemeItemEnum.radioButton
          )
        }"
      />
      <span class="ms-0 me-2">{{ enumValue.label }}</span>
      <input
        class="w-100"
        *ngIf="enumValue.isText"
        (keyup)="onTextChange($event, enumValue)"
        [value]="currentText"
        tabIndex="{{ currentValue.includes(enumValue.value) ? 0 : -1 }}"
      />
    </div>
  </li>
</ul>
